
  import React from "react"
  import Component from "/Users/tnguyen/Work/Personal/personal-site/src/layouts/index.js"
  import data from "/Users/tnguyen/Work/Personal/personal-site/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js